<div class="modal-size" role="dialog">
  <gstar-header-modal [id]="modalId" [title]="title" />
  <gstar-body-modal>
    <p>
      {{ content }}
    </p>
  </gstar-body-modal>
  <gstar-footer-modal
    [id]="modalId"
    [hidePrimaryButton]="hidePrimaryButton"
    (confirmEvent)="confirm()" />
</div>
